export const nav = {
  en: {
    projects: 'Projects',
    experience: 'Experience',
    skills: 'Skills',
    about: 'About',
    education: 'Education',
    contact: 'Contact'
  },
  es: {
    projects: 'Proyectos',
    experience: 'Experiencia',
    skills: 'Habilidades',
    about: 'Sobre mí',
    education: 'Educación',
    contact: 'Contacto'
  }
}
export const ui = {
  en: {
    eyebrow: 'BUILDING SOLUTIONS THAT MATTER',
    work: 'View my work',
    cv: 'Download CV',
    technologies: 'TRUSTED TECHNOLOGIES',
    featured: 'FEATURED PROJECTS',
    featuredSub:
      'Selected products, platforms and solutions developed throughout my career.',
    viewProject: 'View project',
    experience: 'PROFESSIONAL EXPERIENCE',
    techStack: 'Tech stack',
    education: 'EDUCATION',
    coreFocus: 'CORE FOCUS',
    skills: 'TECHNICAL SKILLS',
    about: 'ABOUT ME',
    contact: 'LET’S BUILD SOMETHING GREAT',
    contactText:
      'For professional opportunities, software projects or technical collaboration, feel free to get in touch.',
    references: 'Professional references available upon request.',
    talk: "Let's talk",
    fullExperience: 'View full experience',
    languages: 'LANGUAGES',
    interests: 'PROFESSIONAL OBJECTIVES',
    download: 'Download CV',
    remote: 'Remote, hybrid or on-site',
    learner: 'Self-taught & continuous learner',
    problem: 'Problem solver',
    ai: 'AI-assisted development',
    opportunities: 'Open to opportunities'
  },
  es: {
    eyebrow: 'CONSTRUYENDO SOLUCIONES QUE IMPORTAN',
    work: 'Ver mi trabajo',
    cv: 'Descargar CV',
    technologies: 'TECNOLOGÍAS PRINCIPALES',
    featured: 'PROYECTOS DESTACADOS',
    featuredSub:
      'Selección de productos, plataformas y soluciones desarrolladas durante mi carrera.',
    viewProject: 'Ver proyecto',
    experience: 'EXPERIENCIA PROFESIONAL',
    techStack: 'Tecnologías',
    education: 'EDUCACIÓN',
    coreFocus: 'ENFOQUE PRINCIPAL',
    skills: 'HABILIDADES TÉCNICAS',
    about: 'SOBRE MÍ',
    contact: 'CONSTRUYAMOS ALGO GENIAL',
    contactText:
      'Para oportunidades profesionales, proyectos de software o colaboración técnica, no dudes en contactarme.',
    references: 'Referencias profesionales disponibles a solicitud.',
    talk: 'Hablemos',
    fullExperience: 'Ver experiencia completa',
    languages: 'IDIOMAS',
    interests: 'OBJETIVOS PROFESIONALES',
    download: 'Descargar CV',
    remote: 'Remoto, híbrido o presencial',
    learner: 'Autodidacta y aprendizaje continuo',
    problem: 'Resolutivo',
    ai: 'Desarrollo asistido por IA',
    opportunities: 'Abierto a oportunidades'
  }
}
export const technologies = [
  'PHP',
  'React',
  'TypeScript',
  'JavaScript',
  'PostgreSQL',
  'Symfony',
  'CodeIgniter',
  'Angular',
  'Flutter',
  'MySQL',
  'SQL Server',
  '.NET',
  'Claude AI',
  'Git'
]
export const projects = [
  {
    id: 'reserva',
    title: 'Reserva Ya',
    category: { en: 'SaaS · Web · Mobile', es: 'SaaS · Web · Móvil' },
    description: {
      en: 'Reservation management platform for businesses to manage establishments, services, schedules, users, reservations, catalogs and reports.',
      es: 'Plataforma SaaS de gestión de reservas para administrar establecimientos, servicios, horarios, usuarios, reservas, catálogos y reportes.'
    },
    stack: 'React · Flutter · CodeIgniter 4 · PostgreSQL',
    url: 'https://www.sigmatecteam.com/#portfolio'
  },
  {
    id: 'elc',
    title: 'Estée Lauder E-Commerce',
    category: { en: 'E-Commerce · LATAM', es: 'E-Commerce · LATAM' },
    description: {
      en: 'Front-End and Back-End development for high-traffic Estée Lauder Companies e-commerce sites in Mexico, Chile and Brazil, including checkout features and new payment methods for MAC Cosmetics Mexico.',
      es: 'Desarrollo Front-End y Back-End de sitios e-commerce de alto tráfico de Estée Lauder Companies en México, Chile y Brasil, incluyendo funcionalidades de checkout y nuevos métodos de pago para MAC Cosmetics México.'
    },
    stack: 'PHP · React (TypeScript / JavaScript) · PostgreSQL · Claude AI',
    url: 'https://www.maccosmetics.com.mx/'
  },
  {
    id: 'cnel',
    title: 'CNEL Work Management',
    category: { en: 'Enterprise · Utilities', es: 'Empresarial · Servicio eléctrico' },
    description: {
      en: 'Operations tracking system to manage utility tasks, improving reporting accuracy and field workflow efficiency.',
      es: 'Sistema de seguimiento de operaciones para gestionar tareas del servicio eléctrico, mejorando la precisión de los reportes y la eficiencia del trabajo de campo.'
    },
    stack: 'React · PHP · PostgreSQL',
    url: 'https://www.cnelep.gob.ec/'
  },
  {
    id: 'sngr',
    title: 'SNGR Risk Management',
    category: { en: 'Government · Real-Time', es: 'Gobierno · Tiempo real' },
    description: {
      en: 'Nationwide risk monitoring system enabling real-time data processing and visualization for state-level decision making.',
      es: 'Sistema nacional de monitoreo de riesgos que permite el procesamiento de datos en tiempo real y su visualización para la toma de decisiones a nivel estatal.'
    },
    stack: 'PHP (Symfony) · React · PostgreSQL',
    url: 'https://sagrc.gestionderiesgos.gob.ec/'
  },
  {
    id: 'notify',
    title: 'Mass Notification System',
    category: { en: 'Real-Time · Messaging', es: 'Tiempo real · Mensajería' },
    description: {
      en: 'Real-time message broadcasting platform built and scaled to distribute notifications instantly.',
      es: 'Plataforma de envío de mensajes en tiempo real, desarrollada y escalada para distribuir notificaciones al instante.'
    },
    stack: 'React · PHP · PostgreSQL',
    url: 'https://www.goitsa.me/'
  },
  {
    id: 'doxi',
    title: 'Doxi Regional Microsites',
    category: { en: 'Frontend · LATAM', es: 'Frontend · LATAM' },
    description: {
      en: 'Front-End components for regional consumer-brand microsites, including Pizza Hut Bolivia and Café Martínez Argentina.',
      es: 'Componentes Front-End para micrositios regionales de marcas de consumo como Pizza Hut Bolivia y Café Martínez Argentina.'
    },
    stack: 'Angular · HTML · CSS',
    links: [
      { label: 'Pizza Hut Bolivia', url: 'https://pizzahut.com.bo/' },
      { label: 'Café Martínez Argentina', url: 'https://www.cafemartinez.com/' }
    ]
  }
]
export const experience = [
  {
    company: 'EXPANDYA · Estée Lauder Companies',
    period: '2021 — 2026',
    periodEs: '2021 — 2026',
    role: 'Full-Stack Developer',
    roleEs: 'Desarrollador Full-Stack',
    location: 'New York / Remote',
    locationEs: 'Nueva York / Remoto',
    stack: 'PHP, React (TypeScript / JavaScript), PostgreSQL, Claude (AI)',
    bullets: {
      en: [
        "Led technical maintenance and development of Front-End and Back-End functionality for Estée Lauder Companies' e-commerce platforms within the LATAM team, using PHP, React, and PostgreSQL.",
        'Supported and maintained high-traffic transactional sites serving consumers across multiple LATAM countries, including Mexico, Chile, and Brazil.',
        'Designed and implemented critical checkout features and new payment methods for MAC Cosmetics Mexico, contributing to improved regional conversion.',
        'Developed and deployed automated server-side scripts in PHP for the generation and delivery of business reports and analytics metrics.',
        'Used Claude (Anthropic) as part of the development workflow to optimize and refactor PHP and React/TypeScript code, review changes before release, and support QA with test scenarios and early bug detection.'
      ],
      es: [
        'Lideré el mantenimiento técnico y el desarrollo de funcionalidades Front-End y Back-End de las plataformas de e-commerce de Estée Lauder Companies dentro del equipo LATAM, usando PHP, React y PostgreSQL.',
        'Di soporte y mantenimiento a sitios transaccionales de alto tráfico que atendían a consumidores en varios países de Latinoamérica, incluyendo México, Chile y Brasil.',
        'Diseñé e implementé funcionalidades críticas de checkout y nuevos métodos de pago para MAC Cosmetics México, contribuyendo a mejorar la conversión regional.',
        'Desarrollé e implementé scripts automatizados en PHP del lado del servidor para la generación y envío de reportes de negocio y métricas analíticas.',
        'Usé Claude (Anthropic) como parte del flujo de desarrollo para optimizar y refactorizar código PHP y React/TypeScript, revisar cambios antes de cada despliegue y apoyar el QA con escenarios de prueba y detección temprana de errores.'
      ]
    }
  },
  {
    company: 'Freelance · GOIT S.A.',
    period: 'Various periods',
    periodEs: 'Varios periodos',
    role: 'Consultant & Software Engineer',
    roleEs: 'Consultor e Ingeniero de Software',
    location: 'Ecuador',
    locationEs: 'Ecuador',
    stack: 'PHP (Symfony), React, PostgreSQL, Angular',
    bullets: {
      en: [
        'Work Management System (CNEL – Ecuador): designed and implemented an operations tracking system with React, a PHP back end, and PostgreSQL to manage utility tasks, improving reporting accuracy and field workflow efficiency.',
        'Risk Management System (SNGR – Ecuador): collaborated on a nationwide risk monitoring system built with PHP (Symfony), React, and PostgreSQL, enabling real-time data processing and visualization for state-level decision making.',
        'Mass Notification System: built and scaled a real-time message broadcasting platform using React, PHP, and PostgreSQL.',
        'Regional Microsites (Doxi): developed Front-End components with Angular and HTML for consumer brands including Pizza Hut Bolivia and Café Martínez Argentina.'
      ],
      es: [
        'Sistema de Gestión de Trabajos (CNEL – Ecuador): diseñé e implementé un sistema de seguimiento de operaciones con React, back end en PHP y PostgreSQL para gestionar tareas del servicio eléctrico, mejorando la precisión de los reportes y la eficiencia del trabajo de campo.',
        'Sistema de Gestión de Riesgos (SNGR – Ecuador): colaboré en un sistema nacional de monitoreo de riesgos desarrollado con PHP (Symfony), React y PostgreSQL, que permite el procesamiento de datos en tiempo real y su visualización para la toma de decisiones a nivel estatal.',
        'Sistema de Notificaciones Masivas: desarrollé y escalé una plataforma de envío de mensajes en tiempo real con React, PHP y PostgreSQL.',
        'Micrositios regionales (Doxi): desarrollé componentes Front-End con Angular y HTML para marcas de consumo como Pizza Hut Bolivia y Café Martínez Argentina.'
      ]
    }
  },
  {
    company: 'ARCSA',
    period: '2017 — 2021',
    periodEs: '2017 — 2021',
    role: 'Security and Applications Analyst 2',
    roleEs: 'Analista de Seguridad y Aplicaciones 2',
    location: 'Guayaquil, Ecuador',
    locationEs: 'Guayaquil, Ecuador',
    stack: 'PHP, React, PostgreSQL, MySQL',
    bullets: {
      en: [
        'Led the migration of the core institutional web platform to modern technologies using React and PHP.',
        'Developed internal modules for payroll distribution, reporting databases, and consulting agency lookups using PHP, PostgreSQL, and MySQL.',
        'Monitored, audited, and maintained high availability for the national Operating Permits portal servers, while providing tier-2 technical support.'
      ],
      es: [
        'Lideré la migración de la plataforma web institucional principal a tecnologías modernas usando React y PHP.',
        'Desarrollé módulos internos para distribución de nómina, bases de datos de reportes y consulta de agencias consultoras usando PHP, PostgreSQL y MySQL.',
        'Monitoreé, audité y mantuve la alta disponibilidad de los servidores del portal nacional de Permisos de Funcionamiento, brindando además soporte técnico de nivel 2.'
      ]
    }
  },
  {
    company: 'GURUSOFT',
    period: '2015 — 2017',
    periodEs: '2015 — 2017',
    role: 'Project Lead Engineer',
    roleEs: 'Ingeniero Líder de Proyectos',
    location: 'Guayaquil, Ecuador',
    locationEs: 'Guayaquil, Ecuador',
    stack: '.NET, SQL Server',
    bullets: {
      en: [
        'Led development teams building web applications for Human Resources, Corporate Management, and Accounting ERP systems using .NET and SQL Server.'
      ],
      es: [
        'Lideré equipos de desarrollo en la construcción de aplicaciones web para sistemas ERP de Recursos Humanos, Gestión Corporativa y Contabilidad usando .NET y SQL Server.'
      ]
    }
  },
  {
    company: 'SOLINTEGRA',
    period: '2014 — 2015',
    periodEs: '2014 — 2015',
    role: 'Developer',
    roleEs: 'Desarrollador',
    location: 'Guayaquil, Ecuador',
    locationEs: 'Guayaquil, Ecuador',
    stack: '.NET, SQL Server',
    bullets: {
      en: [
        'Developed scalable enterprise features and integrated new functionality into a corporate ERP system using .NET and advanced SQL Server scripting.'
      ],
      es: [
        'Desarrollé funcionalidades empresariales escalables e integré nuevos requerimientos en un sistema ERP corporativo usando .NET y scripting avanzado en SQL Server.'
      ]
    }
  },
  {
    company: 'Early Professional History',
    companyEs: 'Experiencia inicial',
    period: '2006 — 2013',
    periodEs: '2006 — 2013',
    role: 'Technical & Support Roles',
    roleEs: 'Roles técnicos y de soporte',
    location:
      'Kallpa Crossfit · Cía. General de Construcciones · Grupo Gregor S.A.',
    locationEs:
      'Kallpa Crossfit · Cía. General de Construcciones · Grupo Gregor S.A.',
    bullets: {
      en: [
        'Foundational roles in hardware maintenance, system configuration, user support, and accounting assistance.'
      ],
      es: [
        'Cargos de base en mantenimiento de hardware, configuración de sistemas, soporte a usuarios y asistencia contable.'
      ]
    }
  }
]
export const coreFocus = {
  en: [
    {
      icon: '⚙',
      title: 'Back-End',
      text: 'PHP (Symfony, CodeIgniter), PostgreSQL, REST integrations, server-side automation.'
    },
    {
      icon: '</>',
      title: 'Front-End',
      text: 'React with TypeScript and JavaScript (ES6+), component-based architecture, responsive UI.'
    },
    {
      icon: '◫',
      title: 'Databases',
      text: 'PostgreSQL and SQL: query design, optimization, stored procedures, reporting.'
    },
    {
      icon: '✦',
      title: 'AI-Assisted Development',
      text: 'Claude (Anthropic) for code optimization, refactoring, code review, QA, test generation, and documentation.'
    }
  ],
  es: [
    {
      icon: '⚙',
      title: 'Back-End',
      text: 'PHP (Symfony, CodeIgniter), PostgreSQL, integraciones REST, automatización del lado del servidor.'
    },
    {
      icon: '</>',
      title: 'Front-End',
      text: 'React con TypeScript y JavaScript (ES6+), arquitectura basada en componentes, interfaces responsivas.'
    },
    {
      icon: '◫',
      title: 'Bases de datos',
      text: 'PostgreSQL y SQL: diseño y optimización de consultas, procedimientos almacenados, reportes.'
    },
    {
      icon: '✦',
      title: 'Desarrollo asistido por IA',
      text: 'Claude (Anthropic) para optimización de código, refactorización, revisión de código, QA, generación de pruebas y documentación.'
    }
  ]
}
export const skills = {
  en: [
    [
      'Programming Languages',
      ['PHP', 'TypeScript', 'JavaScript (ES6+)', 'C# / .NET', 'SQL', 'Perl']
    ],
    [
      'Front-End',
      [
        'React',
        'Angular',
        'jQuery',
        'AJAX',
        'HTML5',
        'CSS3',
        'SCSS',
        'Bootstrap'
      ]
    ],
    ['Back-End & Frameworks', ['PHP (Symfony)', 'PHP (CodeIgniter)', '.NET']],
    ['Mobile', ['Flutter']],
    ['Databases', ['PostgreSQL', 'MySQL', 'SQL Server']],
    [
      'AI Tools',
      ['Claude (Anthropic)', 'Code optimization', 'QA', 'Code review']
    ],
    [
      'Methodologies & Tools',
      ['Scrum (Agile)', 'Git', 'Server management', 'Infrastructure monitoring']
    ],
    [
      'Languages',
      ['Spanish — Native', 'English — Professional Working Proficiency']
    ]
  ],
  es: [
    [
      'Lenguajes de programación',
      ['PHP', 'TypeScript', 'JavaScript (ES6+)', 'C# / .NET', 'SQL', 'Perl']
    ],
    [
      'Front-End',
      [
        'React',
        'Angular',
        'jQuery',
        'AJAX',
        'HTML5',
        'CSS3',
        'SCSS',
        'Bootstrap'
      ]
    ],
    ['Back-End y frameworks', ['PHP (Symfony)', 'PHP (CodeIgniter)', '.NET']],
    ['Móvil', ['Flutter']],
    ['Bases de datos', ['PostgreSQL', 'MySQL', 'SQL Server']],
    [
      'Herramientas de IA',
      [
        'Claude (Anthropic)',
        'Optimización de código',
        'QA',
        'Revisión de código'
      ]
    ],
    [
      'Metodologías y herramientas',
      [
        'Scrum (Ágil)',
        'Git',
        'Administración de servidores',
        'Monitoreo de infraestructura'
      ]
    ],
    ['Idiomas', ['Español — Nativo', 'Inglés — Nivel profesional']]
  ]
}
export const education = [
  {
    school: 'Universidad de Guayaquil',
    period: '2009 — 2016',
    degree: {
      en: 'Systems Engineering Degree',
      es: 'Ingeniero en Sistemas'
    },
    detail: {
      en: 'University degree · Ecuador',
      es: 'Título universitario · Ecuador'
    }
  },
  {
    school: 'Colegio Teodoro Alvarado Oleas',
    period: '2000 — 2007',
    degree: {
      en: 'Technical Baccalaureate in IT and Business Administration',
      es: 'Bachillerato Técnico en Informática y Administración de Empresas'
    },
    detail: {
      en: 'Technical secondary education · Ecuador',
      es: 'Formación secundaria técnica · Ecuador'
    }
  }
]
export const professionalInterests = {
  en: [
    'Long-term opportunities in modern development architectures',
    'PHP and React/TypeScript ecosystems',
    'AI-assisted software engineering',
    'Clean code and Agile practices',
    'Collaborative teams',
    'Healthy work-life balance'
  ],
  es: [
    'Oportunidades a largo plazo en arquitecturas de desarrollo modernas',
    'Ecosistemas PHP y React/TypeScript',
    'Ingeniería de software asistida por IA',
    'Código limpio y prácticas ágiles',
    'Equipos colaborativos',
    'Sano equilibrio entre vida personal y laboral'
  ]
}
